import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserFromSession } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUserFromSession(data.user);
        // clean hash
        window.history.replaceState({}, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name}`);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Login failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUserFromSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white" data-testid="auth-callback">
      <div className="squircle border border-[#2b2b2b] px-8 py-6 text-sm text-[#a0a0a0]">
        Signing you in…
      </div>
    </div>
  );
}
